import { Three } from "./three";

export class THREE_INST {
  private static instance: THREE_INST;
  private static threeClass: Three;

  constructor() {
    THREE_INST.threeClass = new Three();
  }

  get obj() {
    return THREE_INST.threeClass;
  }

  static getInst(): THREE_INST {
    if (!this.instance) {
      this.instance = new THREE_INST();
    }
    return this.instance;
  }
}
